module.exports = __webpack_public_path__ + "static/img/Whell 8 inch (Roda Scaffolding 8 x 2).d52174b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Whell 8 inch (Roda Scaffolding 8 x 2).jpg
// module id = 112
// module chunks = 1